import { render, staticRenderFns } from "./syncScroll.vue?vue&type=template&id=42256021"
import script from "./syncScroll.vue?vue&type=script&lang=js"
export * from "./syncScroll.vue?vue&type=script&lang=js"
import style0 from "./syncScroll.vue?vue&type=style&index=0&id=42256021&prod&lang=css"
import style1 from "./syncScroll.vue?vue&type=style&index=1&id=42256021&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports